import { obtainMailBox } from "../bootstrap";
import { nextTokenTopicName } from "../services/TokenService";
export const watchForNewToken = (name, callback) => {
  const uid = Math.floor(Math.random() * 1000000);
  obtainMailBox().buildConsumerClient(`watchForNewToken.${uid}`).subscribeToTopic(nextTokenTopicName(name), (_, __, popAll) => {
    const tokens = popAll();
    if (tokens.length <= 0) {
      // This shouldn't happen if we're getting called here, but just making sure
      return;
    }
    const mostRecentToken = tokens[tokens.length - 1];
    callback(mostRecentToken);
  }, true);
};